import React from 'react';
import i18next from 'i18next';

import SelectOption from '~app/components/SelectOption';

export const WHEN_BUY = {
  ONE_WEEK: 'oneWeek',
  BETWEEN_ONE_WEEK_AND_ONE_MONTH: 'betweenOneWeekAndOneMonth',
  MORE_THAN_ON_MONTH: 'moreThanOneMonth'
};

export const WHEN_BUY_OPTIONS = [
  { value: WHEN_BUY.ONE_WEEK },
  { value: WHEN_BUY.BETWEEN_ONE_WEEK_AND_ONE_MONTH },
  { value: WHEN_BUY.MORE_THAN_ON_MONTH }
];

export const getWhenBuyOptions = () =>
  WHEN_BUY_OPTIONS.map(({ value }) => ({
    label: <SelectOption message={i18next.t(`CreditSimulation:${value}`)} />,
    value
  }));
